import { render, staticRenderFns } from "./cardCoupon.vue?vue&type=template&id=328c67f7&scoped=true"
import script from "./cardCoupon.vue?vue&type=script&lang=js"
export * from "./cardCoupon.vue?vue&type=script&lang=js"
import style0 from "./cardCoupon.vue?vue&type=style&index=0&id=328c67f7&prod&lang=less&scoped=true"
import style1 from "./cardCoupon.vue?vue&type=style&index=1&id=328c67f7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c67f7",
  null
  
)

export default component.exports